import React from "react"
import { LeaderBoard } from "../../models/LeaderBoard"
import { IEntity, IRouterId } from "../../models/Utils"
import { CanLoad } from "../../utils/CanLoad"
import { Router } from "../../utils/Router"
import { RootContext } from "../AppRoot"
import { LeaderBoardDisplay } from "../base/LeaderBoardDisplay"
import { LeaderboardSelector } from "../base/LeaderboardSelector"
import { Tab, Tabs } from "../base/Tabs"

export class Stagione extends CanLoad<IRouterId, IEntity<LeaderBoard>>{
    constructor(props: IRouterId){
        super(props, {
            item: null
        })
    }

    componentDidMount = () => {
        this.checkViewPort()
        window.addEventListener("resize", this.checkViewPort)
    }

    componentDidUpdate = (prevProps: typeof this.props) => {
        const { seasons } = this.context,
        { id } = this.props,
        { item } = this.state,
        season = seasons.find(s => s.season_id === Number(id))

        if(!item && season)
            this.setState({ item: season.leaderboards[0] })
        else if(prevProps.id !== id)
            this.setState({ item: null })
    }

    componentWillUnmount = () => window.removeEventListener("resize", this.checkViewPort)

    checkViewPort = () => {
        const width = document.body.clientWidth,
        { loading } = this.state

        if((width > 900 && loading) || (width <= 900 && !loading))
            this.toggleLoading()
    }

    render = () => <RootContext.Consumer>
        {
            ({ seasons }) => {
                const { id } = this.props,
                season = seasons.find(s => s.season_id === Number(id)),
                { item, loading } = this.state

                return <div className="board-selector">
                    {loading ? <>
                        <LeaderboardSelector key={Router.getWindowUrl() + "_" + item?.episode_id + "_" + season?.season_id} list={season?.leaderboards || []} id={item?.episode_id.toString()} onChange={item => this.setState({ item })} />
                        {item && <LeaderBoardDisplay leaderboard={item.episode_leaderboard} />}
                    </> : <Tabs key={id}>
                        {
                            season?.leaderboards.map(s => <Tab key={s.episode_id} title={s.episode_name}>
                                <LeaderBoardDisplay leaderboard={s.episode_leaderboard} />
                            </Tab>)
                        }
                    </Tabs>}
                </div>
            }
        }
    </RootContext.Consumer>
}